import EncrptionInterceptor from "../lib/encryptionInterceptor";
const url = "querymanager/insurance/web-requests";
const api = EncrptionInterceptor();

// Posts straight to our own kawachgateway_mw -> insurancex_mw, not the old
// external OLMS API. Fully open/unauthenticated (see
// insurancex_mw/src/policies/webRequestPolicy.js) - no authToken needed,
// unlike createLead.js. Common headers + encrypted body come from
// EncrptionInterceptor.
export async function createWebRequest(payload) {
  console.log("Payload", payload);
  const response = await api.post(url, payload);
  return response.data;
}
